var _style, _polygon, _path, _polygon2, _defs, _rect, _defs2, _polygon3, _defs3, _polygon4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFivesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A70F83;}\n\t.st1{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st2{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "382.2,454.6 382.2,454.7 382.2,454.7 382.2,454.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378,472.9L378,472.9L378,472.9z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "291.3,564.8 291.3,564.8 291.4,564.8 291.4,564.7 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M334.3,236.8c0,90.7,73.6,164.3,164.3,164.3c90.7,0,164.2-73.5,164.2-164.3c0-90.7-73.5-164.3-164.2-164.3 C407.9,72.6,334.3,146.1,334.3,236.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: -387.2459,
    cy: 640.7178,
    r: 19.0581,
    gradientTransform: "matrix(8.4424 0 0 -8.4424 3767.8838 5622.6704)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BD0080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4429,
    style: {
      stopColor: "#BD0080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5329,
    style: {
      stopColor: "#B7007C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6511,
    style: {
      stopColor: "#A70072"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7847,
    style: {
      stopColor: "#8C0060"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    style: {
      stopColor: "#660048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9667,
    style: {
      stopColor: "#5B0041"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B0041"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 334.3,
    y: 72.6,
    className: "st1",
    width: 328.5,
    height: 328.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M553.1,267c1.2,2.3,11.2-3.4,25.8-9.1c21.6-8.4,53.4-16.9,81.7,0.8l0.7,0.5l0.1-0.5 c5.5-39.3-6.1-71.1-6.1-71.1C583.8,215.1,550.1,261.3,553.1,267"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -328.3559,
    y1: 630.7238,
    x2: -309.2986,
    y2: 630.7238,
    gradientTransform: "matrix(5.7502 6.613430e-002 6.613430e-002 -5.7502 2399.7839 3876.4373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B50080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2818,
    style: {
      stopColor: "#7C0056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    style: {
      stopColor: "#3E0028"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8703,
    style: {
      stopColor: "#17000B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#080000"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "550.1,186.4 667.8,187.7 666.8,270.7 549.2,269.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M526,105.5c-8.4,0.2-17.6,1.7-27.5,5.1c-42.9,14.9-67.7,62.2-92.4,162.1c-1.5-0.5-2.9-0.9-4.2-1.4 c-20.5-7.1-30.3-15.4-30.3-15.4c-0.5-0.6-1-0.6-1.3-0.6c0,0-0.1,0-0.1,0c-1,0.1-1.1,2.4-1.1,2.4c-0.2,39.4,24.9,49,28.8,50.2 c-3.4,15.5-6.9,32.1-10.5,49.8v0c14,12.9,30.4,23.4,48.3,30.8c0,0,1.1-30.4,6.4-70.6c20.6-1.6,37.8-5.7,52-10.9 c36.2-13.4,52.3-33.6,53.3-34.7c1.4-1.5,0.9-2.1,0.5-2.4c-0.2-0.1-1.2,0-2.2,0.1c-1,0.2-2.1,0.4-2.1,0.4 c-4.1,1.1-8.1,2.1-12.1,2.9c-33.3,7.6-61.2,9-83.8,7.2c13.3-74.6,40.9-160.5,97.1-159.7c8.3,0.1,17.3,2.1,26.9,6.3 c2.4,1.1,4.9,2.2,7.4,3.6c0,0,4.8,2.1,6.5,0.8c0,0,0,0,0,0c0.1-0.1,0.5-0.7-1.6-2.7c0,0-21.2-23.4-56.5-23.4 C527.1,105.5,526.6,105.5,526,105.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -508.6748,
    y1: 709.1276,
    x2: -489.6175,
    y2: 709.1276,
    gradientTransform: "matrix(-6.3743 17.3614 17.3614 6.3743 -15010.8662 4380.1938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2619,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4968,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6171,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7922,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    style: {
      stopColor: "#BCBCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    style: {
      stopColor: "#AFAFB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#281E1C"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "678,139.1 560.5,459 277.3,355 394.7,35.1  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,451.2c0,0-2-35.4,7.3-45.7c9.6-10.7,28.2-6.8,28.4-6.8c0.2,0.1,6.3,2.2,10.8,8.4 c3.8,5.1,14.6,11.7,23.1,6c0,0,5.2-2.8,5.2-11.1c0-8.4-11.9-11.3-16.9-11.9c0,0-30.5-3.8-49.1,2c-18.6,5.9-30.5,15.1-30.5,59.2 h-16.1v14.9h16.1v104h21.5v-104h38.6c0,0,13-0.9,13,12.6V570h21.3V449.2c0,0-6.8,1.9-24.2,1.9H17.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "129.7,451.2 155.9,537.6 182.1,451.2 202.5,451.2 164.5,570 147.2,570 109.3,451.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295,513.4V506c0-16.9-4-30.7-11.8-40.9c-8-10.5-18.1-15.8-30-15.8c-13.3,0-24.3,5.7-32.7,16.9 c-8.2,11-12.4,25.9-12.4,44.3c0,18.7,4.7,33.9,13.8,45c9.3,11.3,21.7,17,36.8,17c0,0,18.3,0.4,32.5-7.7l-3.3-17.4 c-15.5,6.7-29.1,6.3-29.1,6.3c-8.7,0-15.9-3.9-22-11.7c-5.6-7.3-8.7-16.6-9.1-27.7l0-1H295z M228.8,495.6l0.1-1.1 c0.9-7.5,3.5-13.7,7.5-18.5c4.7-5.4,10.3-8,17.3-8c5.3,0,9.9,2.7,14.3,8.3c3.9,5,6.1,11.1,6.6,18.3l0.1,1H228.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.6,565.3l3.7-18.8l2.5,1.4c7.9,4.3,16.4,6.5,25.4,6.5c7.7,0,14-1.7,18.7-4.9c4.6-3.1,6.8-7.2,6.8-12.4 c0-3.5-1.1-6.6-3.4-9.3c-1.5-1.9-5.8-5-17-9c-7.7-2.7-13.4-4.8-16.8-6.1c-3.8-1.4-7.4-3.6-10.6-6.3c-3.3-2.8-5.8-6.2-7.5-10.1 c-1.7-3.8-2.6-8.2-2.6-13c0-10.4,4-18.7,11.9-24.9c7.8-6,18.1-9.1,30.8-9.1c8.1,0,17.2,1.6,27,4.8l1.7,0.6v0l-4.2,18.2v0h0h0 l-2.2-0.9c-7.9-3-15.5-4.5-22.5-4.5c-7.5,0-13.5,1.4-17.7,4.3c-4.1,2.7-6.1,6.3-6.1,10.7c0,2.8,0.9,5.2,2.7,7.3 c1.9,2.2,5.9,4.3,11.9,6.2c0,0,7,2.3,7,2.3l7.5,2.5c6.7,2.2,11.6,4.7,15.9,7.7c4.3,3.1,7.6,7,9.8,11.4c2.2,4.4,3.2,9.6,3.2,15.4 c0,11.4-4.2,20.5-12.5,27.2c-8.2,6.5-18.7,9.9-31.3,9.9C343.7,572.6,325.3,573.3,311.6,565.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFivesLogo);
export default __webpack_public_path__ + "static/media/fivesLogo.d37ef4064ecdaff47fe3de5864ade76c.svg";
export { ForwardRef as ReactComponent };